$(function(){
    /**
     * @deprecated Please us the hide-show-behavior instead
     * Show target element on click
     *
     * Usage example:
     *
     *
     * <a data-show="#hidden-box" data-show-alt-html="Hide visible box" href="#">Show hidden box</a>
     *
     * <div id="hidden-box" class="hide">
     *     I am hidden
     * </div>
     *
     */
    $(document).on('click', '[data-show]', function(e){
        console.warn("Using a deprecated behaviour. Please us the hide-show-behaviour instead!");
        e.preventDefault();
        var link = $(this);
        var scrollTo = link.is('[data-show-scroll-to]');
        var hideLink = link.is('[data-show-hide-link]');
        var style = 'hide';
        if(link.data('show-style')){
            style = link.data('show-style');
        }
        var defaultHtml = link.data('show-default-html');
        if(!defaultHtml){
            defaultHtml = link.html();
            link.data('show-default-html', defaultHtml);
        }
        var altHtml = link.data('show-alt-html');
        if(!altHtml){
            altHtml = defaultHtml;
            link.data('show-alt-html', altHtml);
        }
        var selector = link.data('show');
        var target = $(selector);
        //hide
        if(target.is(':visible')){
            if(style == 'hide'){
                target.addClass('hide');
            }
            else if(style == 'slide'){
                target.slideUp();
            }
            link.html(defaultHtml);
        }
        //show
        else{
            target.removeClass('hide hide-for-small hide-for-medium-down');
            if(style == 'slide'){
                target.slideDown();
            }
            link.html(altHtml);
            if(hideLink){
                link.css('display', 'none');
            }
            if(scrollTo){
                setTimeout(function(){
                    $.scrollTo(target, {
                        'duration': 250,
                        'offset': -50
                    });
                }, 250);
            }
        }
    });
});